import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'angular-bootstrap-md';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Clothes } from 'src/app/models/Clothes';
import { DataOrder } from 'src/app/models/DataOrder';
import { Family } from 'src/app/models/Family';
import { InfoObservation } from 'src/app/models/InfoObservation';
import { NocSizes } from 'src/app/models/NocSizes';
import { Order } from 'src/app/models/Order';
import { UseConditions } from 'src/app/models/UseConditions';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BlockService } from 'src/app/services/block.service';
import { ClothesService } from 'src/app/services/clothes.service';
import { FamilyService } from 'src/app/services/family.service';
import { ObservationService } from 'src/app/services/observation.service';
import { OrderService } from 'src/app/services/order.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';

declare var jQuery: any;

@Component({
  selector: 'app-order-request',
  templateUrl: './order-request.component.html',
  styleUrls: ['./order-request.component.scss']
})
export class OrderRequestComponent implements OnInit {
  @ViewChild('filtro') filtro: ModalDirective;
  @ViewChild('myModal', {static: false} as any) myModal!: ModalDirective;


  public familiesCatalog: any;
  public familiesFilter: {
    name: string;
    code: string;
    subFamilies: string[]
  }[];
  public families: Family[];
  public listFamily: Family[] = [];
  public itemAnteriorI: number;
  public itemAnteriorD: string;
  public codeAnterior: string;
  public subItemSelected: boolean;
  public itemSelected: string;
  public clothes: Clothes[];
  public infoObservation: InfoObservation;
  public dataObservation: {
    ribbon: string[],
    job: string[],
    weapon: string[],
    generalStaff: string[]
  }
  public selectedClothes: {
    name: string,
    code: string,
    points: number,
    enabled: boolean,
    amount: number,
    maxAmount: number,
    max: number,
    userSize: string,
    images: string[],
    sizes: string[], 
    sizesStock: string[], 
    description: string,
    composition: string,
    useConditions: UseConditions[],
    observation: {
      ribbon: string[],
      job: string[],
      weapon: string[];
      generalStaff: string[],
      observation: string,
      isObservation: boolean
    },
    observationUser: {
      ribbon: string,
      job: string,
      weapon: string,
      generalStaff: string,
      observation: string
    }
  }[];
  public articulosGuardados: {
    name: string,
    credit: string,
    amount: number,
    image: string,
    size: string,
    codeCloth: string,
    team: string,
    ribbon: string,
    job: string,
    weapon: string,
    generalStaff: string,
    observation: string
  }[];
  public clothesAuxWithData: Clothes[] = [];
  public familySelected: string;
  public modificarArticulos: boolean = false;
  public savedOrder: Order;
  public dataOrder: DataOrder;
  public clothesList: string[];
  public imagesUrl: string = CONSTANTES.imagesUrl;
  public description : string;
  public startDate : Date;
  public endDate : Date;
  public bloqueado: boolean = false;
  public cardCloth: Clothes = undefined;

  public keyword: any;

  public infoObservations: InfoObservation = new InfoObservation();

  NocSizes = NocSizes;

  item: Clothes = undefined
  detailModal = false
  clothSelected: string = ''


  constructor(private spinner: NgxSpinnerService, private router: Router, private familyService: FamilyService,
    private toastr: ToastrService, private authService: AuthenticationService, private clothesService: ClothesService,
    private orderService: OrderService, private blockService: BlockService , private observationService: ObservationService) { }

  ngOnInit() {
    this.spinner.show();
    try{
      jQuery.getScript(CONSTANTES.menu);
    } catch(Error){
      this.router.navigate(['login']);
    }
				    this.checkBloqueado();
    this.articulosGuardados = [];
  }

  //Obtiene la informacion sobre las posibles observaciones
  getInfoObservation(){
    this.dataObservation = { ribbon:[], job:[], weapon:[], generalStaff:[]};
    this.observationService.getInfoObservation().subscribe(
      data => {
        if (getToken(data)){

          if (data.ribbon !== undefined && data.ribbon !== null &&
            data.job !== undefined && data.job !== null && 
            data.weapon !== undefined && data.weapon !== null && 
            data.generalStaff !== undefined && data.generalStaff !== null){

              for (let element in data.job){
                this.dataObservation.job.push(element);
                this.infoObservations.job.set(element,data.job[element]);
              }
              this.dataObservation.job.sort((a, b) => {
                if (a < b) {
                  return -1;
                } else if (a > b) {
                  return 1;
                } else {
                  return 0;
                }
              });
              
              for (let element in data.ribbon){
                this.dataObservation.ribbon.push(element);
                this.infoObservations.ribbon.set(element,data.ribbon[element]);
              }
              this.dataObservation.ribbon.sort((a, b) => {
                if (a < b) {
                  return -1;
                } else if (a > b) {
                  return 1;
                } else {
                  return 0;
                }
              });
              
              for (let element in data.weapon){
                this.dataObservation.weapon.push(element);
                this.infoObservations.weapon.set(element,data.weapon[element]);
              }
              this.dataObservation.weapon.sort((a, b) => {
                if (a < b) {
                  return -1;
                } else if (a > b) {
                  return 1;
                } else {
                  return 0;
                }
              });

              for (let element in data.generalStaff){
                this.dataObservation.generalStaff.push(element);
                this.infoObservations.generalStaff.set(element,data.generalStaff[element]);
              }
              this.dataObservation.generalStaff.sort((a, b) => {
                if (a < b) {
                  return -1;
                } else if (a > b) {
                  return 1;
                } else {
                  return 0;
                }
              });
           
          }
          this.getSavedOrders();
        }
        
      }, error => {
        this.toastr.error(error);
        this.logOut();
      }
    );
  }

  // Obtiene los pedidos guardados del usuario
  getSavedOrders(){
    let dataOrder: DataOrder = {
      nid: localStorage.getItem("nid"),
      dataBank: null,
      user: null,
      domain: null,
      errorCode: null,
      id: null,
      orders: null,
      status: null,
      token: null,
      receiptOrders: null,
      orderNumberBank: null,
      orderPending: null,
      pdfName: null,
      role: localStorage.getItem("role"),
      noc: null
    }
    this.orderService.getOrdersToConfirm(dataOrder).subscribe(
      data => {
        if (getToken(data)){
          if (data.orders !== undefined && data.orders !== null && data.orders.length > 0){
            this.savedOrder = data.orders[0];
            this.dataOrder = data;
            this.savedOrder.orderDetails.forEach(orderDetail => {
              // Ordenamos los precios por fecha
              orderDetail.clothes.prices.sort((a, b) => {
                if (a.priceDate < b.priceDate) {
                  return -1;
                } else if (a.priceDate > b.priceDate) {
                  return 1;
                } else {
                  return 0;
                }
              });
              if(orderDetail.generalStaff===null){
                this.articulosGuardados.push({
                  amount: orderDetail.amount,
                  codeCloth: orderDetail.clothes.code,
                  credit: (orderDetail.clothes.prices[orderDetail.clothes.prices.length - 1].price).toString(),
                  name: orderDetail.clothes.name,
                  size: orderDetail.size,
                  team: null,
                  image: null,
                  generalStaff: null,
                  job: null,
                  observation: '',
                  weapon: null,
                  ribbon: null
                });
              }else{
                this.articulosGuardados.push({
                  amount: orderDetail.amount,
                  codeCloth: orderDetail.clothes.code,
                  credit: (orderDetail.clothes.prices[orderDetail.clothes.prices.length - 1].price).toString(),
                  name: orderDetail.clothes.name,
                  size: orderDetail.size,
                  team: null,
                  image: null,
                  generalStaff: orderDetail.generalStaff.description,
                  job: orderDetail.job.description,
                  observation: orderDetail.observation,
                  weapon: orderDetail.weapon.description,
                  ribbon: orderDetail.ribbon.description
                });
              }
              
            });
            localStorage.setItem("articulos", this.savedOrder.orderDetails.length.toString());
            this.orderService.sendUpdate(this.savedOrder.orderDetails.length.toString());
            this.orderService.changeTime(this.savedOrder.confirmDate.toString());
            this.orderService.changeStatus(this.savedOrder.status);
            //this.orderService.currentArticles = new BehaviorSubject(this.savedOrder.orderDetails.length.toString()).asObservable();
          }
        }
        this.loadFamilies();
      }, error => {
        this.toastr.error(error);
        this.logOut();
      }
    );
  }

  // Carga las familias de los artÃ­culos
  loadFamilies(){
    this.familyService.getFamiliesCatalog().subscribe(
      data => {
        if (getToken(data)){
          this.families = data.families;
          this.familiesCatalog = data.familiesCatalog;
          this.familiesFilter = [];
          for (let i = 0; i < this.families.length; i++) {
            if (this.families[i].parent === null) {
              this.listFamily.push(this.families[i]);
              this.familiesFilter.push({
                name: this.families[i].name,
                code: this.families[i].code,
                subFamilies: this.familiesCatalog[this.families[i].name]
              });
            }
          }
          this.loadClothes();
        }
      }, error => {
        this.toastr.error(error);
        this.logOut();
      }
    )
  }

  // Se sacan los subitems en el filtro cada vez que se pulse en el item principal
  /*subItems(family: any, i: number, d: string) {
    this.familySelected = family.name;
    let item = <HTMLInputElement>document.getElementById("item" + d + family.code + i);
    let subItems = <HTMLElement>document.getElementById("subItems" + d + family.code + i);

    if (this.itemAnteriorD != undefined && this.itemAnteriorI != undefined && this.codeAnterior != undefined) {
      let itemAnterior = <HTMLInputElement>document.getElementById("item" + this.itemAnteriorD + this.codeAnterior + this.itemAnteriorI);
      itemAnterior.checked = false;
    }

    if (this.subItemSelected == false || this.subItemSelected == null)
      item.checked = true;
    if (subItems != null) {
      if (item.checked === true) {
        subItems.style.height = "";
        subItems.style.marginTop = "-1.8em";
        subItems.style.marginBottom = "1.7em";
        this.subItemSelected = true;
        this.itemSelected = family.name;
        this.getItems(family.name, null);

      } else {
        subItems.style.height = "0px";
        subItems.style.marginTop = "";
        subItems.style.marginBottom = "";
        this.subItemSelected = false;
      }
    }

    this.itemAnteriorD = d;
    this.itemAnteriorI = i;
    this.codeAnterior = family.code;

  }

  // Se filtran los articulos y se muestran
  getItemsCatalogo(family: any, subfamily: string, d: string, i: number) {
    this.spinner.show();
    this.familySelected = family.name;
    let item = <HTMLInputElement>document.getElementById("item" + d + family.code + i);

    this.itemSelected = item.nextSibling.textContent;

    item.checked = true;
    // aqui se controla que se desmarque el checkbox del anterior marcado
    if (this.itemAnteriorD != undefined && this.itemAnteriorI != undefined && this.codeAnterior != undefined) {
      let itemAnterior = <HTMLInputElement>document.getElementById("item" + this.itemAnteriorD + this.codeAnterior + this.itemAnteriorI);
      if (this.itemAnteriorI === i && this.itemAnteriorD === d && this.codeAnterior === family.code)
        itemAnterior.checked = true;
      else
        itemAnterior.checked = false;

      if (this.subItemSelected === true && d != "SM" && i != 0) {
        let subItem = <HTMLInputElement>document.getElementById("item" + d + family.code + "0");
        //this.itemSelected = subItem.nextSibling.textContent
        subItem.checked = false;
        this.subItems(family, 0, d);
      }

    }

    this.itemAnteriorI = i;
    this.itemAnteriorD = d;
    this.codeAnterior = family.code;

    this.getItems(family.name, subfamily);

  }*/

  subItems(family: any, i: number, d: string) {
    this.spinner.show();
    this.familySelected = family.name;
    let item = <HTMLInputElement>document.getElementById("item" + d + family.code + i);
    let subItems = <HTMLElement>document.getElementById("subItems" + d + family.code + i);

    if (this.itemAnteriorD != undefined && this.itemAnteriorI != undefined && this.codeAnterior != undefined) {
      let itemAnterior = <HTMLInputElement>document.getElementById("item" + this.itemAnteriorD + this.codeAnterior + this.itemAnteriorI);
      itemAnterior.checked = false;
    }

    if (this.subItemSelected == false || this.subItemSelected == null)
      item.checked = true;
    if (subItems != null) {
      if (item.checked === true) {
        this.subItemSelected = true;
        this.itemSelected = family.name;
        this.getItems(family.name, null);

      } else {
        this.subItemSelected = false;
        this.spinner.hide();
      }
    }

    this.itemAnteriorD = d;
    this.itemAnteriorI = i;
    this.codeAnterior = family.code;

  }

  // Se filtran los articulos y se muestran
  getItemsCatalogo(family: any, subfamily: string, d: string, i: number) {
    this.spinner.show();
    this.familySelected = family.name;
    let item = <HTMLInputElement>document.getElementById("item" + d + family.code + i);

    this.itemSelected = item.nextSibling.textContent;

    item.checked = true;
    // aqui se controla que se desmarque el checkbox del anterior marcado
    if (this.itemAnteriorD != undefined && this.itemAnteriorI != undefined && this.codeAnterior != undefined) {
      let itemAnterior = <HTMLInputElement>document.getElementById("item" + this.itemAnteriorD + this.codeAnterior + this.itemAnteriorI);
      if (this.itemAnteriorI === i && this.itemAnteriorD === d && this.codeAnterior === family.code)
        itemAnterior.checked = true;
      else
        itemAnterior.checked = false;

      if (this.subItemSelected === true && d != "SM" && i != 0) {
        let subItem = <HTMLInputElement>document.getElementById("item" + d + family.code + "0");
        //this.itemSelected = subItem.nextSibling.textContent
        subItem.checked = false;
        this.subItems(family, 0, d);
      }

    }

    this.itemAnteriorI = i;
    this.itemAnteriorD = d;
    this.codeAnterior = family.code;

    this.getItems(family.name, subfamily);

  }


  // Muestra los Items pertenecientes a la familia seleccionada en el filtro
  getItems(family: string, subfamily: string){
    let familieAux = null;
    // Si no se ha seleccionado familia, se muestran todos los artÃ­culos
    this.selectedClothes = [];
    let sizes: string[];
    let sizesStock: string[];
    if (family === null){
      this.clothesService.getAllVisibleClothes().subscribe(
        data => {
          if (getToken(data)){
            if (data.clothes !== undefined && data.clothes !== null && data.clothes.length > 0){
              this.clothesAuxWithData = data.clothes;
            }
            this.clothesAuxWithData.forEach(element => {
              sizes = [];
              let obsr = {
                ribbon: [],
                job: [],
                weapon: [],
                generalStaff: [],
                observation: '',
                isObservation: false
              };
              let obsrUser = {
                ribbon: null,
                job: null,
                weapon: null,
                generalStaff: null,
                observation: null
              };
              if (element.nocSizes !== null){
                element.nocSizes.forEach(nocSize => {
                  if(sizes.indexOf('S/T')===-1)
                      sizes.push(nocSize.size);
                  sizesStock.push(nocSize.size); 
                });
              }
              // Ordenamos los precios por fecha
              element.prices.sort((a, b) => {
                if (a.priceDate < b.priceDate) {
                  return -1;
                } else if (a.priceDate > b.priceDate) {
                  return 1;
                } else {
                  return 0;
                }
              });
      
              let images: string[] = [];
      
              if (element.pictures === undefined || element.pictures.length === 0){
                images.push("default.png");
              } else {
                element.pictures.forEach(picture => {
                  if (picture.deleted === false && picture.fileName !== null){
                    images.push(picture.fileName);
                  }
                });
                if (element.pictures.length === 0){
                  images.push("default.png");
                }
              }
              if (element.observations !== undefined && element.observations.length !== 0){
                element.observations.forEach(observations => {
                  if(observations.type==="Comentario"){
                    obsr.ribbon = this.dataObservation.ribbon;
                    obsr.job = this.dataObservation.job;
                    obsr.weapon = this.dataObservation.weapon;
                    obsr.generalStaff = this.dataObservation.generalStaff;
                    obsr.observation = '';
                    obsr.isObservation = true;
                  }
                });
              }
              this.selectedClothes.push({
                name: element.name,
                code: element.code,
                points: (element.prices[element.prices.length-1] !== undefined ? element.prices[element.prices.length-1].price : 0),
                amount: 0,
                enabled: element.visible,
                images: images,
                max: 0,
                maxAmount: 0,
                userSize: null,
                sizes: sizes,
                sizesStock: sizesStock,
                composition: element.composition,
                description: element.description,
                useConditions: element.useConditions,
                observation: obsr,
                observationUser: obsrUser
              });
            });
          }
          if (this.selectedClothes.length > 0){
            this.filtro.hide();
          }
          this.spinner.hide();
        },
        error => {
          this.toastr.error(error);
          this.logOut();
        }
      );
    } else if (subfamily === null){ // Si se ha seleccionado familia pero subfamilia no, se muestran los artÃ­culos que pertenezcan a esa familia
      familieAux = this.families.filter(fam => fam.parent != null && fam.parent.name === family);
      this.selectedClothes = [];
      familieAux.forEach(fa => {
        this.clothesService.getVisibleClothesByFamily(fa).subscribe(
          data => {
            if (getToken(data)){
              if (data.clothes !== undefined && data.clothes !== null && data.clothes.length > 0){
                this.clothesAuxWithData = data.clothes;
              }
              this.clothesAuxWithData.forEach(element => {
                let obsr = {
                  ribbon: [],
                  job: [],
                  weapon: [],
                  generalStaff: [],
                  observation: '',
                  isObservation: false
                };
                let obsrUser = {
                  ribbon: null,
                  job: null,
                  weapon: null,
                  generalStaff: null,
                  observation: null
                };
                // Si en las familias del artÃ­culo estÃ¡ incluida la seleccionada, se aÃ±ade el artÃ­culo a la lista de seleccionados
                if (element.family.parent.name === family){
                  sizes = [];
                  sizesStock = [];
                  if (element.nocSizes !== null && element.nocSizes.length > 0){
                    element.nocSizes.forEach(nocSize => {
                      if(sizes.indexOf('S/T')===-1)
                        sizes.push(nocSize.size);
                      sizesStock.push(nocSize.size); 
                    });
                  } else {
                    sizes.push("S/T");
                  }
  
                  let images: string[] = [];
  
                  if (element.pictures === undefined || element.pictures.length === 0){
                    images.push("default.png");
                  } else {
                    element.pictures.forEach(picture => {
                      if (picture.deleted === false && picture.fileName !== null){
                        images.push(picture.fileName);
                      }
                    });
                    if (element.pictures.length === 0){
                      images.push("default.png");
                    }
                  }
                  if (element.observations !== undefined && element.observations.length !== 0){
                    element.observations.forEach(observations => {
                      if(observations.type==="Comentario"){
                        obsr.ribbon = this.dataObservation.ribbon;
                        obsr.job = this.dataObservation.job;
                        obsr.weapon = this.dataObservation.weapon;
                        obsr.generalStaff = this.dataObservation.generalStaff;
                        obsr.observation = '';
                        obsr.isObservation = true;
                      }
                    });
                  }
                  this.selectedClothes.push({
                    name: element.name,
                    code: element.code,
                    points: (element.prices[element.prices.length-1] !== undefined ? element.prices[element.prices.length-1].price : 0),
                    amount: 0,
                    enabled: element.visible,
                    images: images,
                    max: 0,
                    maxAmount: 0,
                    userSize: null,
                    sizes: sizes,
                    sizesStock: sizesStock,
                    composition: element.composition,
                    description: element.description,
                    useConditions: element.useConditions,
                    observation: obsr,
                    observationUser: obsrUser
                  });
                }
              });
            }
            if (this.selectedClothes.length > 0){
              this.filtro.hide();
            }
            this.spinner.hide();
          },
          error => {
            this.toastr.error(error);
            this.logOut();
          }
        );
      });
      
    } else { // Si se ha seleccionado subfamilia, se muestran los artÃ­culos pertenecientes
      familieAux = this.families.find(fam => fam.parent != null && fam.parent.name === family && fam.name === subfamily);
      this.clothesService.getVisibleClothesByFamily(familieAux).subscribe(
        data => {
          if (getToken(data)){
            if (data.clothes !== undefined && data.clothes !== null && data.clothes.length > 0){
              this.clothesAuxWithData = data.clothes;
            }
            this.selectedClothes = [];
            this.clothesAuxWithData.forEach(element => {
              let obsr = {
                ribbon: [],
                job: [],
                weapon: [],
                generalStaff: [],
                observation: '',
                isObservation: false
              };
              let obsrUser = {
                ribbon: null,
                job: null,
                weapon: null,
                generalStaff: null,
                observation: null,
              };
              // Si en las familias del artÃ­culo estÃ¡ incluida la seleccionada, se aÃ±ade el artÃ­culo a la lista de seleccionados
              if (element.family.name === subfamily && element.family.parent.name === family){
                sizes = [];
                sizesStock = [];
                if (element.nocSizes !== null && element.nocSizes.length > 0){
                  element.nocSizes.forEach(nocSize => {
                    if(sizes.indexOf('S/T')===-1)
                      sizes.push(nocSize.size);
                    sizesStock.push(nocSize.size);  
                  });
                } else {
                  sizes.push("S/T");
                }
      
                let images: string[] = [];
      
                if (element.pictures === undefined || element.pictures.length === 0){
                  images.push("default.png");
                } else {
                  element.pictures.forEach(picture => {
                    if (picture.deleted === false && picture.fileName !== null){
                      images.push(picture.fileName);
                    }
                  });
                  if (element.pictures.length === 0){
                    images.push("default.png");
                  }
                }
                if (element.observations !== undefined && element.observations.length !== 0){
                  element.observations.forEach(observations => {
                    if(observations.type==="Comentario"){
                      obsr.ribbon = this.dataObservation.ribbon;
                      obsr.job = this.dataObservation.job;
                      obsr.weapon = this.dataObservation.weapon;
                      obsr.generalStaff = this.dataObservation.generalStaff;
                      obsr.observation = '';
                      obsr.isObservation = true;
                    }
                  });
                }
                this.selectedClothes.push({
                  name: element.name,
                  code: element.code,
                  points: (element.prices[element.prices.length-1] !== undefined ? element.prices[element.prices.length-1].price : 0),
                  amount: 0,
                  enabled: element.visible,
                  images: images,
                  max: 0,
                  maxAmount: 0,
                  userSize: null,
                  sizes: sizes,
                  sizesStock: sizesStock,
                  composition: element.composition,
                  description: element.description,
                  useConditions: element.useConditions,
                  observation: obsr,
                  observationUser: obsrUser
                });
              }
            });
          }
          if (this.selectedClothes.length > 0){
            this.filtro.hide();
          }
          this.spinner.hide();
        },
        error => {
          this.toastr.error(error);
          this.logOut();
        }
      );
    }
  }

  updateMaxAmount(index: number){
    this.selectedClothes[index];
    let mod:boolean = true;
    this.clothesAuxWithData.forEach(clothes => {
      if (clothes.name === this.selectedClothes[index].name){
        return clothes.nocSizes.forEach(nocSize => {
          if(this.selectedClothes[index].observation.isObservation){
            if (nocSize.size === this.selectedClothes[index].userSize && 
              nocSize.generalStaff.description === this.selectedClothes[index].observationUser.generalStaff &&
              nocSize.job.description === this.selectedClothes[index].observationUser.job &&
              nocSize.ribbon.description === this.selectedClothes[index].observationUser.ribbon &&
              nocSize.weapon.description === this.selectedClothes[index].observationUser.weapon){
              // Comprobamos si estÃ¡ en el pedido guardado para rellenar la cantidad seleccionada
              mod = false;
              if (this.savedOrder !== undefined && this.savedOrder !== null){
                this.savedOrder.orderDetails.forEach(orderDetail => {
                  if (orderDetail.clothes.name === this.selectedClothes[index].name && 
                    nocSize.generalStaff.description === this.selectedClothes[index].observationUser.generalStaff &&
                    nocSize.job.description === this.selectedClothes[index].observationUser.job &&
                    nocSize.ribbon.description === this.selectedClothes[index].observationUser.ribbon &&
                    nocSize.weapon.description === this.selectedClothes[index].observationUser.weapon){
                    return this.selectedClothes[index].amount = orderDetail.amount;
                  }
                });
              }
              return this.selectedClothes[index].max = (nocSize.stock - nocSize.threshold <= 0 ? 0 : nocSize.stock - nocSize.threshold);
            }
          }else{
            if (nocSize.size === this.selectedClothes[index].userSize){
              // Comprobamos si estÃ¡ en el pedido guardado para rellenar la cantidad seleccionada
              if (this.savedOrder !== undefined && this.savedOrder !== null){
                this.savedOrder.orderDetails.forEach(orderDetail => {
                  if (orderDetail.clothes.name === this.selectedClothes[index].name){
                    return this.selectedClothes[index].amount = orderDetail.amount;
                  }
                });
              }
              return this.selectedClothes[index].max = (nocSize.stock - nocSize.threshold <= 0 ? 0 : nocSize.stock - nocSize.threshold);
            }
          }
        });
      }
    });
    if(this.selectedClothes[index].observation.isObservation && mod){
      return this.selectedClothes[index].max=0;
    }
  }

  // cambia el valor del slider
  cantidad(nombre: string, i: number, val) {
    document.getElementById("cantidad_" + nombre.split(' ').join('_') + "_" + i).innerHTML = val;

  }

  // aÃ±adir item al carrito
  addItemToCart(item: any, index: number) {

    let sliderCantidad = <HTMLInputElement>document.getElementById("amount_" + item.name.split(' ').join('_') + "_" + index);
    let cantidadArticulo = sliderCantidad.valueAsNumber;

    // si la cantidad es menor o igual que 0 no se almacena el producto
    if (cantidadArticulo <= 0) {
      this.toastr.warning("DEBE SELECCIONAR UNA CANTIDAD MAYOR QUE 0 DEL PRODUCTO", "CANTIDAD");
      return;
    }
    let nameItem = item.name;
    let creditItem = item.points;
    let imageItem = item.image;
    let size = item.userSize;
    let codeCloth = item.code;
    let ribbonItem = item.observationUser.ribbon;
    let weaponItem = item.observationUser.weapon;
    let generalStaffItem = item.observationUser.generalStaff;
    let jobItem = item.observationUser.job;

    let sliderObservation = <HTMLInputElement>document.getElementById("observation_" + item.name.split(' ').join('_') + "_" + index);
    let obserItem; 
    if(generalStaffItem!==undefined && generalStaffItem!==null){
      obserItem = sliderObservation.value;
    }
    

    if (this.articulosGuardados.length > 0) {
      for (let i = 0; i < this.articulosGuardados.length; i++) {
        // si el producto ya esta almacenado se elimina para su posterior modificaciÃ³n por si ha cambiado de cantidad.
        if ((this.articulosGuardados[i].name === nameItem && this.articulosGuardados[i].size === size 
            && this.articulosGuardados[i].generalStaff=== generalStaffItem && this.articulosGuardados[i].job===jobItem
            && this.articulosGuardados[i].ribbon===ribbonItem && this.articulosGuardados[i].weapon===weaponItem)) {
          if(this.articulosGuardados[i].amount !== cantidadArticulo){
            this.articulosGuardados.splice(i, 1);
          } else {
            this.toastr.warning("YA DISPONE DE ESA CANTIDAD DEL ARTICULO EN SU PEDIDO GUARDADO", "ARTICULO EXISTENTE");
            return;
          }
        }
      }

    }

    // se almacenan los productos para mostrarlos en el carrito de compra
    this.articulosGuardados.push(
      {
        name: nameItem,
        credit: creditItem,
        amount: cantidadArticulo,
        image: imageItem,
        size: size,
        codeCloth: codeCloth,
        team: this.familySelected,
        generalStaff: generalStaffItem,
        job: jobItem,
        weapon: weaponItem,
        ribbon: ribbonItem, 
        observation: obserItem
      }
    );
    if (this.savedOrder === undefined || this.savedOrder === null) {
      this.guardarPedido();
    }
    else {
      this.modificarPedido();
    }

  }

  // Obtiene todos los artÃ­culos
  loadClothes(){
    this.clothesService.getClothesWithoutData().subscribe(
      data => {
        if (getToken(data)){
          if (data.clothes !== undefined && data.clothes !== null && data.clothes.length > 0){
            this.clothes = [];
            this.clothesList = [];
            // Obtenemos solo los artÃ­culos visibles
            data.clothes.forEach(element => {
                this.clothes.push(element);
                this.clothesList.push(element.name);
            });
          }
          // this.getItems(null, null);
        }
        this.spinner.hide();
      },
      error => {
        this.toastr.error(error);
        this.logOut();
      }
    );
  }

  /**
   * Obtiene la informacion del articulo seleccionado
   * @param item 
   */
  getSelectedItem(item: Clothes){
    let cloth = this.clothes.find(cloth => cloth.name === item.name)
    if(cloth != undefined){
      this.clothesService.getClothById(cloth.id).subscribe(
        data => {
          if (getToken(data)){
            if (data.clothes !== undefined && data.clothes !== null && data.clothes.length > 0){
              this.clothesAuxWithData = data.clothes;
            }
            this.item = data.clothes[0]
            this.selectedClothes = [];
            this.clothesAuxWithData.forEach(element => {
              let sizes = [];
              let sizesStock = [];
              let obsr = {
                ribbon: [],
                job: [],
                weapon: [],
                generalStaff: [],
                observation: '',
                isObservation: false
              };
              let obsrUser = {
                ribbon: null,
                job: null,
                weapon: null,
                generalStaff: null,
                observation: null
              };
              if (element.name === item.name){
                if (element.nocSizes !== null){
                  element.nocSizes.forEach(nocSize => {
                    if(sizes.indexOf('S/T')===-1)
                      sizes.push(nocSize.size);            
                    sizesStock.push(nocSize.size);
                  });
                }
                let images: string[] = [];

                if (element.pictures === undefined || element.pictures.length === 0){
                  images.push("default.png");
                } else {
                  element.pictures.forEach(picture => {
                    if (picture.deleted === false && picture.fileName !== null){
                      images.push(picture.fileName);
                    }
                  });
                  if (element.pictures.length === 0){
                    images.push("default.png");
                  }
                }
                if (element.observations !== undefined && element.observations.length !== 0){
                  element.observations.forEach(observations => {
                    if(observations.type==="Comentario"){
                      obsr.ribbon = this.dataObservation.ribbon;
                      obsr.job = this.dataObservation.job;
                      obsr.weapon = this.dataObservation.weapon;
                      obsr.generalStaff = this.dataObservation.generalStaff;
                      obsr.observation = '';
                      obsr.isObservation = true;
                    }
                  });
                }
                this.selectedClothes.push({
                  name: element.name,
                  code: element.code,
                  points: (element.prices[element.prices.length-1] !== undefined ? element.prices[element.prices.length-1].price : 0),
                  amount: 0,
                  enabled: element.visible,
                  images: images,
                  max: 0,
                  maxAmount: 0,
                  userSize: null,
                  sizes: sizes, 
                  sizesStock: sizesStock,
                  composition: element.composition,
                  description: element.description,
                  useConditions: element.useConditions,
                  observation: obsr,
                  observationUser: obsrUser
                });
              }
            });
          }
        },
        error => {
          this.toastr.error(error);
          this.logOut();
        }
      );
    }
  }

  // Guarda el pedido
  guardarPedido() {

    this.spinner.show();
    // inicializamos el objeto
    this.savedOrder = {
      orderNumber: null,
      creationDate: new Date,
      id: null,
      orderDetails: [],
      price: 0,
      requestDate: null,
      sigle: false,
      sigleDate: null,
      status: "CONFIRMED",
      user: null,
      orderNumberBank: null,
      orderType: (localStorage.getItem("role") !== "TIENDA FISICA" ? "ONLINE" : "TIENDA_FISICA"),
      address: null,
      confirmDate: null,
      preparation: false,
      preparationDate: null,
      shipment: false,
      shipmentDate: null,
      shipmentReference: null ,
      storeTicketNumber: null,
    }

    // AÃ±adimos los artÃ­culos a los detalles del pedido
    for (let articulo of this.articulosGuardados) {
      let cloth: Clothes;
      this.clothesAuxWithData.forEach(element => {
        if (element.name === articulo.name){
          return cloth = element;
        }
      });
      if (cloth.nocSizes !== null){
        cloth.nocSizes.forEach(nocSize => {
          if(nocSize.generalStaff!==null && nocSize.job!==null && nocSize.ribbon !==null && nocSize.weapon!==null){
            if ((nocSize.size === articulo.size && nocSize.generalStaff.description===articulo.generalStaff &&
              nocSize.job.description===articulo.job && nocSize.ribbon.description===articulo.ribbon
              && nocSize.weapon.description===articulo.weapon)){
              if (localStorage.getItem("role") !== "TIENDA FISICA" && nocSize.maxAmount < articulo.amount){
                this.savedOrder.confirmDate = null;
                return this.savedOrder.status = "SAVED";
              }
            }  
          } else if (nocSize.size === articulo.size) {
            if (localStorage.getItem("role") !== "TIENDA FISICA" && nocSize.maxAmount < articulo.amount){
              this.savedOrder.confirmDate = null;
              this.savedOrder.status = "SAVED";
            }
          }
        });
      }
      if(articulo.generalStaff===null || articulo.generalStaff.length<=0){
        this.savedOrder.orderDetails.push({
          amount: articulo.amount,
          size: articulo.size,
          clothes: cloth,
          isChecked: null,
          generalStaff: null,
          job: null,
          ribbon: null,
          weapon: null,
          observation: '',
          height: null,
          thorax: null,
          waist: null,
          pinGroup: null,
          pinObservation: ''
        });
      }else{
        this.savedOrder.orderDetails.push({
          amount: articulo.amount,
          size: articulo.size,
          clothes: cloth,
          isChecked: null,
          generalStaff: {id:this.infoObservations.generalStaff.get(articulo.generalStaff), description:articulo.generalStaff},
          job: {id:this.infoObservations.job.get(articulo.job), description:articulo.job},
          ribbon: {id:this.infoObservations.ribbon.get(articulo.ribbon), description:articulo.ribbon},
          weapon: {id:this.infoObservations.weapon.get(articulo.weapon), description:articulo.weapon},
          observation: articulo.observation,
          height: null,
          thorax: null,
          waist: null,
          pinGroup: null,
          pinObservation: ''
        });
      }
      
      this.savedOrder.price += +articulo.credit * articulo.amount;
    }

    // AÃ±adimos la fecha de confirmaciÃ³n
    this.savedOrder.confirmDate = new Date();

    this.dataOrder = {
      domain: null,
      errorCode: null,
      id: null,
      user: null,
      nid: localStorage.getItem("nid"),
      orders: [],
      dataBank: null,
      status: null,
      token: null,
      receiptOrders: null,
      orderNumberBank: null,
      orderPending: null,
      pdfName: null,
      role: null,
      noc: null
    };
    this.dataOrder.orders.push(this.savedOrder);

    this.orderService.saveOrder(this.dataOrder).subscribe(
      data => {
        if (getToken(data)) {
          if (this.savedOrder.status === "SAVED"){
            this.toastr.show("EL ARTICULO HA SIDO GUARDADO CORRECTAMENTE. EL PEDIDO DEBERA SER VALIDADO.", "ARTICULO A�ADIDO",{
              toastClass: "ngx-toastr toast-success toastAddItem"
            });
          } else {
            this.toastr.show("EL ARTICULO HA SIDO GUARDADO CORRECTAMENTE", "ARTICULO A�ADIDO",{
              toastClass: "ngx-toastr toast-success toastAddItem"
            });
          }
          localStorage.setItem("articulos", this.savedOrder.orderDetails.length.toString());
          this.orderService.sendUpdate(this.savedOrder.orderDetails.length.toString());
          this.orderService.changeTime(this.savedOrder.confirmDate.toString());
          this.orderService.changeStatus(this.savedOrder.status);
          //this.orderService.currentArticles = new BehaviorSubject(this.savedOrder.orderDetails.length.toString()).asObservable();
          this.articulosGuardados = [];
          this.getSavedOrders();
          //this.orderService.changeMessage(this.articulosGuardados.length.toString());
        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
          // Vaciamos la lista de artÃ­culos guardados ya que ha dado error
          this.articulosGuardados = [];

        }
        this.spinner.hide();
      },
      error => {

        this.spinner.hide();

      }
    ) 
  }

  // se modifica el pedido si estÃ¡ confirmado
  modificarPedido() {
    this.spinner.show();
    // si hay articulos guardados
    if (this.articulosGuardados.length > 0) {
      let j = 0;
      this.savedOrder.price = 0;
      // recorremos los articulos guardados
      for (let articulo of this.articulosGuardados) {
        let insert = true;
        if (this.savedOrder.orderDetails.length > 0) {
          // aÃ±adimos al objeto de modificar el pedido los articulos guardados
          for (let orderDetail of this.savedOrder.orderDetails) {
            if (orderDetail.clothes.code === articulo.codeCloth && orderDetail.size === articulo.size 
              && (orderDetail.job===null || orderDetail.job.description === articulo.job) 
              && (orderDetail.ribbon===null || orderDetail.ribbon.description === articulo.ribbon)
              && (orderDetail.generalStaff===null || orderDetail.generalStaff.description===articulo.generalStaff) 
              && (orderDetail.weapon===null || orderDetail.weapon.description===articulo.weapon)) {
              if (articulo.amount === 0){
                articulo.amount = orderDetail.amount;
              }
              this.savedOrder.price += +articulo.credit * articulo.amount;
              orderDetail.amount = articulo.amount;
              insert = false;
            }
          }

        }
        // AÃ±adimos el artÃ­culo al pedido
        if (insert === true){
          let cloth;
          this.clothesAuxWithData.forEach(element => {
            if (element.name === articulo.name){
              return cloth = element;
            }
          })
          if(articulo.generalStaff===null || articulo.generalStaff.length<=0){
            this.savedOrder.orderDetails.push({
              amount: articulo.amount,
              size: articulo.size,
              clothes: cloth,
              isChecked: null,
              generalStaff: null,
              job: null,
              ribbon: null,
              weapon: null,
              observation: '',
              height: null,
              thorax: null,
              waist: null,
              pinGroup: null,
              pinObservation: ''
            });
          }else{
            this.savedOrder.orderDetails.push({
              amount: articulo.amount,
              size: articulo.size,
              clothes: cloth,
              isChecked: null,
              generalStaff: {id:this.infoObservations.generalStaff.get(articulo.generalStaff), description:articulo.generalStaff},
              job: {id:this.infoObservations.job.get(articulo.job), description:articulo.job},
              ribbon: {id:this.infoObservations.ribbon.get(articulo.ribbon), description:articulo.ribbon},
              weapon: {id:this.infoObservations.weapon.get(articulo.weapon), description:articulo.weapon},
              observation: articulo.observation,
              height: null,
              thorax: null,
              waist: null,
              pinGroup: null,
              pinObservation: ''
            });
          }

          this.savedOrder.price += +articulo.credit * articulo.amount;
        }
      }
    }

    // Se pone el estado CONFIRMED por defecto
    this.savedOrder.status = "CONFIRMED";

    // Comprobamos las cantidades para poner el estado del pedido SAVED
    if (localStorage.getItem("role") !== "TIENDA FISICA"){
      this.savedOrder.orderDetails.forEach(orderDetail => {
        // En el momento que se haya solicitado mÃ¡s cantidad de la permitida de un artÃ­culo se pone el estado SAVED
        return orderDetail.clothes.nocSizes.forEach(nocSize => {
          if(nocSize.generalStaff!==null && nocSize.job!==null && nocSize.ribbon !==null && nocSize.weapon!==null){
            if ((nocSize.size === orderDetail.size && nocSize.generalStaff.description===orderDetail.generalStaff.description &&
              nocSize.job.description===orderDetail.job.description && nocSize.ribbon.description===orderDetail.ribbon.description
              && nocSize.weapon.description===orderDetail.weapon.description)){
              if (nocSize.maxAmount < orderDetail.amount){
                this.savedOrder.confirmDate = null;
                return this.savedOrder.status = "SAVED";
              }
            }  
          }else{
            if ((nocSize.size === orderDetail.size)){
              if (nocSize.maxAmount < orderDetail.amount){
                this.savedOrder.confirmDate = null;
                return this.savedOrder.status = "SAVED";
              }
            }
          }
        })
      });
    }

    // AÃ±adimos la fecha de confirmaciÃ³n
    this.savedOrder.confirmDate = new Date();

    this.dataOrder.domain = null;
    this.dataOrder.token = null;
    this.dataOrder.errorCode = null;
    this.orderService.modifyOrder(this.dataOrder).subscribe(
      data => {
        if (getToken(data)) {
          if (this.savedOrder.status === "SAVED"){
            this.toastr.success("SU PEDIDO HA SIDO MODIFICADO CORRECTAMENTE. DEBERA SER VALIDADO.", "PEDIDO MODIFICADO");
          } else {
            this.toastr.success("SU PEDIDO HA SIDO MODIFICADO CORRECTAMENTE", "PEDIDO MODIFICADO");
          }
          localStorage.setItem("articulos", this.savedOrder.orderDetails.length.toString());
          this.articulosGuardados = [];
          this.getSavedOrders();
          this.orderService.sendUpdate(this.savedOrder.orderDetails.length.toString());
          this.orderService.changeTime(this.savedOrder.confirmDate.getTime().toString());
          this.orderService.changeStatus(this.savedOrder.status);
          //this.orderService.currentArticles = new BehaviorSubject(this.savedOrder.orderDetails.length.toString()).asObservable();
        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
        }
        this.spinner.hide();

      },
      error => {
        this.toastr.warning("SU PEDIDO NO HA SIDO MODIFICADO", "ERROR MODIFICAR PEDIDO");
        this.spinner.hide();
      }
    )
  }

  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

  /**Permite obtener el individuo*/
  selectEvent(item) {
    this.selectedClothes = []
    // do something with selected item
    let cloth = new Clothes;
    cloth.name = item;
    this.getSelectedItem(cloth);
  }

  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onFocused(e){
    // do something when input is focused
  }
  
    checkBloqueado() {
    let fecha = new Date();
    this.blockService.getBlockApp().subscribe(
      data => {
        if (fecha <= data.endDate && fecha >= data.initialDate) {
          this.description = data.description;
          this.startDate = data.initialDate;
          this.endDate = data.endDate;
          this.bloqueado = true;
          this.spinner.hide();
        } else {
          //this.getSavedOrders();
           this.getInfoObservation();
        }
      });
  }

  openDetailModal(item: any){
    this.cardCloth = item
    this.detailModal = !this.detailModal
  }

}
